var _classCallCheck = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var list = require('postcss').list;

var Value = require('../value');

var CrossFade = /*#__PURE__*/function (_Value) {
  "use strict";

  _inherits(CrossFade, _Value);

  var _super = _createSuper(CrossFade);

  function CrossFade() {
    _classCallCheck(this, CrossFade);

    return _super.apply(this, arguments);
  }

  _createClass(CrossFade, [{
    key: "replace",
    value: function replace(string, prefix) {
      var _this = this;

      return list.space(string).map(function (value) {
        if (value.slice(0, +_this.name.length + 1) !== _this.name + '(') {
          return value;
        }

        var close = value.lastIndexOf(')');
        var after = value.slice(close + 1);
        var args = value.slice(_this.name.length + 1, close);

        if (prefix === '-webkit-') {
          var match = args.match(/\d*.?\d+%?/);

          if (match) {
            args = args.slice(match[0].length).trim();
            args += ", ".concat(match[0]);
          } else {
            args += ', 0.5';
          }
        }

        return prefix + _this.name + '(' + args + ')' + after;
      }).join(' ');
    }
  }]);

  return CrossFade;
}(Value);

CrossFade.names = ['cross-fade'];
module.exports = CrossFade;